import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, Button, Icon } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { getPageRoute } from "src/services";
import { UpgradeConsumerButton } from "../../upgrades/consumer/UpgradeConsumerButton.js";
import { AuthContext } from "src/utils/AuthContext.js";
import { customEvent } from "src/utils/gtag.js";

const GroupsUpgradeBanner = ({ sx }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    customEvent({
      name: "groups_banner_shown",
      category: "upgrade_banner",
      label: "groups_library_banner_load",
      data: {
        user_id: user?._id,
        user_email: user?.email,
      },
    });
  }, [user]);

  const handleSeeBenefits = () => {
    navigate(getPageRoute("upgrade", "UPGRADE_PLUS"), {
      state: { source: "groups_library_upgrade_banner_benefits" },
    });
  };

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        border: `2px solid ${theme.palette.border.primary}`,
        borderRadius: { xs: "12px", sm: "16px" },
        padding: 5,
        mb: 3,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
        ...sx,
      }}
    >
      {/* Title with icon */}
      <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "flex-start", sm: "center" }, gap: 1 }}>
        <Icon
          baseClassName="material-symbols-outlined"
          sx={{
            fontSize: { xs: "20px", sm: "24px" },
            color: theme.palette.primary.main,
            fontWeight: 300,
          }}
        >
          folder
        </Icon>
        <Typography
          variant="title"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
          }}
        >
          Create Groups with Stanza+
        </Typography>
      </Box>

      {/* Subtitle */}
      <Typography
        variant="body1"
        sx={{
          mt: 1,
          mb: 3,
          color: theme.palette.text.secondary,
          lineHeight: 1.5,
        }}
      >
        For example: create a “Netflix” group to track all your Netflix shows in one calendar. Organize and simplify your calendar.
      </Typography>

      {/* Buttons */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
        }}
      >
        <UpgradeConsumerButton
          variant="contained"
          size="shrinked"
          state={{ source: "groups_library" }}
          sx={{
            flex: { xs: "1 1 auto", sm: "0 1 auto" },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          Try 7 Days Free
        </UpgradeConsumerButton>
        <Button
          variant="outlined"
          size="shrinked"
          onClick={handleSeeBenefits}
          sx={{
            flex: { xs: "1 1 auto", sm: "0 1 auto" },
          }}
        >
          See all benefits
        </Button>
      </Box>
    </Box>
  );
};

export default GroupsUpgradeBanner;
